import Loadable from "@loadable/component";

const Wishlist = Loadable(
  () => import(/* webpackChunkName: "wishlist_page" */ "./wishlist")
);

export default Wishlist;
